var $ = global.jQuery
    , ko = require('knockout')
    , core = require('CoreModule')
    , events = core.Events
    , models = { GalleryKey: require('GalleryKey') }
    , helpers = require('Helpers')
    , controllerEvents = require('ControllerEvents.js');

function SplashScreenViewModel(init) {

    //var resizeHandler = core.Helpers.makeOnResizeDistribute([$('#splashUpper'),$('#splashContainer'), $('#splashLower')]);

    var resizeHandler = core.Helpers.makeOnResizeDistribute25percent50percent([$('#splashUpper'), $('#splashLower')]);
    
   var storageProvider = ko.storage.createStorageProvider('splash', 'guest', 7 * 24 * 60 * 60000);
    

    events.emitter.on(events.resize, resizeHandler);

    SplashScreenViewModel.prototype.dispose = function () {
        console.error("Disposing SplashScreenViewModel....");
        events.emitter.removeListener(events.resize, resizeHandler);
    }

    if (!init.RequestGalleryKey)
    {
        events.emitter.emit(events.gallery_details_requested);
    }
    //events.emitter.emit(events.gallery_details_requested);

    var self = this;
    console.error('SplashScreenViewModel constructor', init, self);
    self.InterControllerEmitter = init.InterControllerEmitter;
    
    self.greeting          = ko.observable("Powered by Fieldology");
    self.busy              = ko.observable();
    self.GalleryDetails    = ko.observable();
    self.RequestGalleryKey = ko.observable(init.RequestGalleryKey);
    self.NewGalleryKey     = ko.observable(init.CurrentGalleryKey)
                                .extend(storageProvider)
                             // .extend({ required: { params: true, message: 'Please enter gallery key' } })
                                .extend({ validateGuid:true });

    self.NewGalleryKey.subscribe(events.makeTrigger(core.Events.error, null));
        
    self.history = ko.observableArray(init.History);
    

    // self.history = ko.observableArray([
    //     { GalleryKey : "3B3437EC-C39C-4323-A0F6-6697DA1C8156", Name : "Ferrero Grocery"},
    //     { GalleryKey : "B78223AF-74BE-4394-98D3-81B84A69F97D", Name : "THL 2017"},
    //     { GalleryKey : "C19EBB91-003C-4620-B917-05DFDEF9A428", Name : "PG RetailX"},
    //     { GalleryKey : "50B4FEDD-1DD9-43EC-B2A7-B60531DF27FD", Name : "PH Sircle"},
    //     { GalleryKey : "4BBF1E02-34A4-454F-A205-B6A1BB2EB8BF", Name : "Ferrero Impulse"},
    //     { GalleryKey : "FC141E54-4991-48B3-B013-00096E6133A1", Name : "Ferrero Cash&Carry"},
    //     { GalleryKey : "2CE0AA8B-F3EC-4A36-814D-7CB8752FCB40", Name : "Ferrero NPD"},
    //     { GalleryKey : "0CE8CDA0-8ECA-4379-84B3-874E68A2BCF1", Name : "Tactical Savse"},
    //     { GalleryKey : "3A4885E9-C1F7-4476-B3A5-2FFDCFDE977A", Name : "Gillette Test"},
    //     { GalleryKey : "239379F5-65D2-47F7-BA65-387845A694A5", Name : "PG Gillette Internal"},
    //     { GalleryKey : "2AE08E7A-2633-426A-8F5D-22371B5B80CE", Name : "PG Gillette External"},
    //     { GalleryKey : "ED4C1A1D-11E6-405C-B554-E225BE0FDD14", Name : "PG Gillette Internal"},
    //     { GalleryKey : "993EC95C-DCA9-4DB1-B223-1EAE1DA1D681", Name : "PG Gillette External"}

    // ]);

    cssClassFromKey = function(key){

        console.log('spin', key);
        return 'bg-' + (key ? Math.abs(core.Helpers.hashCode(key)) % 5 : 'add');

    }

    self.latestHistory = ko.pureComputed(function(){

        var history = self.history();

        return _(history)
            .take(7)
            .tap(function(a){ a.push(helpers.createInstanceWithValues(models.GalleryKey, { Name: 'Add' }))})
            .map(function(x){ return _.assign(x, { css : cssClassFromKey(x.GalleryKey) })  })
            .value();
               
    });
    
    self.remove = function(historyItem, e){

        e.stopPropagation();
        
        console.log('remove', historyItem);

        self.history.remove(historyItem);

        events.emitter.emit(events.remove_history_item, historyItem.GalleryKey );

    }

    self.saveAndGo = function () {

        self.busy(true).saveGalleryKey();        
    }
    
    self.triggerSaveAndGo = function (d, e) {

        e.stopPropagation();
        e.keyCode === 13 && self.saveAndGo();
    };

    self.ManuallyAddingGalleryKey = ko.observable(false);

    ko.bindingHandlers.expand = {
        init: function(element) {

            $(element).addClass('collapse').attr('aria-expanded', false);//.collapse('hide');

        },
        update: function(element, valueAccessor) {

            $(element).collapse(ko.unwrap(valueAccessor()) ? 'show' : 'hide' );
        }
    };

    self.revisit = function(historyItem){

        console.log('revisit', historyItem);

        historyItem.GalleryKey ? self.NewGalleryKey(historyItem.GalleryKey).saveAndGo()
                               : self.NewGalleryKey(null).ManuallyAddingGalleryKey(true).NewGalleryKey.isModified(false);
    }
    
    self.cancelNewGalleryKey = function(){

        self.ManuallyAddingGalleryKey(false);
    }

    self.saveGalleryKey = function () {

        events.emitter.emit(events.gallery_save_key, self.NewGalleryKey().toUpperCase());
    }

     self.goToGallery = function () {

        console.log('goToGallery');
        events.emitter.emit(events.gallery_home_selected);
    }

    self.addingGallery = ko.observable(false);

    self.addGallery = function(){
        self.RequestGalleryKey(true)
        self.addingGallery(true)
    }
    self.cancelAddGallery = function(){
        self.RequestGalleryKey(false)
        self.addingGallery(false)
    }

    // self.InterControllerEmitter.on(controllerEvents.gallery_details_loaded, function (galleryDetails) {

    //     console.error('on(controllerEvents.gallery_details_loaded', galleryDetails);
         
    //     self.busy(false);
    //     galleryDetails  ? self.goToGallery()
    //                     : events.emitter.emit(core.Events.error, 'Please check the gallery key and try again');
    
    //     /*
    //     if (!galleryDetails) {
    //         self.RequestGalleryKey(true);
    //     } else {
    //         self.GalleryDetails(galleryDetails);
    //         self.addingGallery(false)
    //         self.RequestGalleryKey(false);

    //     }
    //     */

    // });
}

module.exports = {
    viewModel: SplashScreenViewModel
    , template: require('SplashScreenView.html')
    , title: 'Home'

};